export enum OrderCreationCustomerRole {
	None,
	Customer,
	Agency,
	Client
}
